import {curry, lensPath, over as _over} from 'ramda';

export const over = curry((path, f, obj) => _over(lensPath(path), f, obj));
